import { ChevronLeftIcon, ChevronRightIcon, IconBoxButton, Text } from '@thefarmersfront/kitchen';

import { formatDate } from '~/utils';

import styles from './CalendarTopBar.module.scss';

type TypeCalendarTopbarProps = {
  currentDate: Date;
  isPrevDisabled?: boolean;
  isNextDisabled?: boolean;
  rightField?: React.ReactNode;
  onPrevMonth: () => void;
  onNextMonth: () => void;
};

const CalendarTopBar = ({
  currentDate,
  isPrevDisabled,
  isNextDisabled,
  onPrevMonth,
  onNextMonth,
  rightField,
}: TypeCalendarTopbarProps) => {
  return (
    <div className={styles['calendar-top-field']}>
      <div className={styles['calendar-top-left']}>
        <IconBoxButton color="tertiary" variant="outlined" size="small" disabled={isPrevDisabled} onClick={onPrevMonth}>
          <ChevronLeftIcon />
        </IconBoxButton>
        <Text size="xxxlarge" weight="bold">
          {formatDate(currentDate, 'YYYY년 MM월')}
        </Text>
        <IconBoxButton color="tertiary" variant="outlined" size="small" disabled={isNextDisabled} onClick={onNextMonth}>
          <ChevronRightIcon />
        </IconBoxButton>
      </div>
      <div className={styles['calendar-top-right']}>{rightField}</div>
    </div>
  );
};

export default CalendarTopBar;
